// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"52007c19","70":"2c0381b3","110":"5af5fb63","179":"7a5a0909","198":"95d691f6","366":"444eb962","378":"cdf6fa71","391":"7593295a","480":"2bdf4954","521":"5f6e4182","615":"d25cb686","672":"36ae1983","685":"d5f29ac2","743":"c649fc18","777":"12ee901a","784":"1b8373ef"}[chunkId] + ".chunk.js";
};